// Shared dark/light theme hook for all GamesNFans pages.
// Each page calls this once and applies `theme` to its root wrapper's className
// (Tailwind's `dark:` variant then activates for every nested element automatically —
// no prop-drilling needed beyond the root div + the GamesNav toggle button itself).
import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'games_theme';

function getInitialTheme() {
  if (typeof window === 'undefined') return 'dark';
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (e) { /* localStorage unavailable — fall back to default */ }
  return 'dark';
}

export function useGamesTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, theme); } catch (e) { /* ignore */ }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme };
}
